import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';
import { Button } from '@app/src/components/Button';

export const FormFields = styled.div`
  width: 100%;

  @media(min-width: 1024px) {
    width: 45%;
  }
`;

export const FormOptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media(min-width: 1024px) {
    display: block;
  }
`;

export const Separator = styled.hr`
  display: none;

  @media(min-width: 1024px) {
    display: block;
    border: 1px dashed;
  }
`;

export const FormSide = styled.div`
  width: 100%;
  font-family: ${FONTS.ROBOTO_REGULAR};
  @media(min-width: 1024px) {
    width: 45%;
  }
`;

export const Title= styled.p`
  margin-bottom: 14px;
`;

export const FormContent = styled.div`
  display: block;

  @media(min-width: 1024px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const ShimmerContent = styled(FormContent)`
  margin: 20px 0 0 0;
  width: 100%;
`;

export const ShimmerFields = styled(FormFields)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  div {
    margin-bottom: 25px;
    display: flex;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    padding: 0 10px;
    div {
      width: 100%;
    }
  }
`;

export const ShimmerSide = styled(FormSide)`
  div {
    margin-bottom: 15px;
  }
  @media (max-width: 480px) {
    display: none;
  }
`;

export const FormWrapper = styled.form`
  width: 100%;
  padding: 0 16px;

  @media(min-width: 480px) {
    padding: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 18px;
  margin-top: 27px;

  @media(min-width: 1024px) {
    justify-content: flex-end;
    width: 45%;
    margin-top: 0px;
  }
`;

export const CleanFieldsButton = styled(Button)`
  background: transparent;
  border: none;
  text-decoration: underline;
  padding: 0;
`;

export const GenerateButton = styled(Button)`
  display: block;

  @media(min-width: 1024px) {
    display: none;
  }
`;

export const GenerateWrapper = styled.div`
  display: none;

  @media(min-width: 1024px) {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  background-color: #F7F7F7;
  border: 2px ${COLORS.BORDER_GRAY};
  border-radius: 5px;
  border-style: solid;
  box-sizing: border-box;
  height: 178px;
  padding: 20px;
  margin-top: 34px;

  p {
    width: 100%;
    color: ${COLORS.BLACK};
  }
`;

export const Link = styled.div`
  width: 100%;
  height: 37px;
  background: #E8E8E8;
  padding: 10px;
  margin: 13px auto;
`;

export const LinkButton = styled.button`
  cursor: pointer;
  background-color: ${COLORS.AQUA_BLUE};
  border: none;
  border-radius: 4px;
  color: ${COLORS.WHITE};
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  min-height: 40px;
  width: 155px;
`;

export const LinkButtonMessage = styled.div`
  background-color: ${COLORS.AQUA_BLUE};
  border-radius: 4px;
  font-size: 14px;
  color: ${COLORS.WHITE};
  min-height: 40px;
  line-height: 40px;
  text-align: center;
  width: 155px;
`;

export const Error = styled.div`
  width: 100%;
  min-height: 30px;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
`;

export const PageError = styled.div`
  font-family: ${FONTS.ROBOTO_REGULAR};
  margin: 20px 0 0;
  h1 {
    margin: 0 0 10px;
  }
  span {
    display: block;
    margin: 5px 0 0;
  }
`;
